<div class="electrip-form">
    <h2>Add New Provider</h2>
    <form [formGroup]="providerForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput required formControlName="name">
        </mat-form-field>
        <button type="submit" mat-button primary [disabled]="!providerForm.valid">Submit</button>


    </form>
</div>